import { combineReducers, configureStore } from "@reduxjs/toolkit";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import globalReducer from "./global/global";
import shopReducer from "./shop/shop";
import customerReducer from "./customer/customer";
import authorReducer from "./author/author";
import authReducer from "./auth/auth";
import eksplodeReducer from "./eksplode/eksplode";
import {
  addBookReducer,
  bookOrderReducer,
  fetchBookOrderReducer,
  fetchBookReducer,
  preOrderBooksReducer,
} from "./books/reducer";
import { fetchCusArticlesReducer } from "./articles/reducer";
import { fetchWalletReducer } from "./wallet/reducers";
import { adCardReducer } from "./adCard/reducers";

const rootReducer = combineReducers({
  global: globalReducer,
  auth: authReducer,
  shop: shopReducer,
  customer: customerReducer,
  author: authorReducer,
  eksplode: eksplodeReducer,
  preorders: preOrderBooksReducer,
  book: fetchBookReducer,
  bookOrder: bookOrderReducer,
  userOrders: fetchBookOrderReducer,
  customerArticles: fetchCusArticlesReducer,
  wallet: fetchWalletReducer,
  addBook: addBookReducer,
  adCards: adCardReducer,
});

const persistConfig = { key: "root", version: 1, storage };

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

let persistor = persistStore(store);

export { store, persistor };
